import React from 'react';
import { FileTextIcon, DumbbellIcon, TargetIcon, UsersIcon, CheckIcon } from 'lucide-react';
const tags = ['U8', 'U10', 'U12', 'U14', 'U16', 'U18', 'Batting', 'Bowling', 'Fielding', 'Tactics', 'Match Prep', 'Assessment'];
const stats = [{
  icon: FileTextIcon,
  value: '200+',
  label: 'Pages'
}, {
  icon: DumbbellIcon,
  value: '50+',
  label: 'Sessions'
}, {
  icon: TargetIcon,
  value: '60+',
  label: 'Drills'
}, {
  icon: UsersIcon,
  value: 'All',
  label: 'Age Groups'
}];
export function SolutionSection() {
  return <section className="w-full bg-gradient-to-b from-[#0A0A0A] to-[#16161F] py-20 px-4" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-212">
          <div className="inline-flex items-center gap-2 bg-[#d4af37] text-[#0A0A0A] font-bold text-[11px] sm:text-xs px-5 py-2 rounded-full mb-8 tracking-wider uppercase shadow-md" data-id="element-213">
            🏆 THE COMPLETE SYSTEM TO STOP IMPROVISING CRICKET TRAINING
          </div>

          <h2 className="text-4xl sm:text-6xl font-black text-white mb-4 tracking-tight" data-id="element-214">
            CRICKET <span className="text-[#d4af37]" data-id="element-215">READY™</span>
          </h2>

          <div className="inline-flex items-center gap-2 mb-6" data-id="element-216">
            <span className="h-px w-8 bg-[#d4af37]" data-id="element-217" />
            <p className="text-[#d4af37] text-base sm:text-lg font-black uppercase tracking-widest" data-id="element-218">
              1 Complete Volume + 5 Strategic Bonuses
            </p>
            <span className="h-px w-8 bg-[#d4af37]" data-id="element-219" />
          </div>

          <p className="text-[#B0B0C0] text-base sm:text-lg mx-auto font-medium leading-relaxed" data-id="element-220">
            Over 200 pages. 50+ professional sessions. 60+ drills. Batting,
            Bowling, Fielding. Physical Preparation. Team Management.{' '}
            <strong className="text-white" data-id="element-221">Everything ready.</strong>
          </p>
        </div>

        {/* Stat cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12" data-id="element-222">
          {stats.map(({
          icon: Icon,
          value,
          label
        }) => <div key={label} className="bg-[#0A0A0A] border border-[#d4af37]/20 rounded-2xl p-6 text-center shadow-sm flex flex-col items-center" data-id="element-223">
              <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#d4af37]/10 mb-4" data-id="element-224">
                <Icon className="w-6 h-6 text-[#d4af37]" strokeWidth={2.5} data-id="element-225" />
              </span>
              <div className="text-3xl sm:text-4xl font-black text-white tracking-tight leading-none mb-1" data-id="element-226">
                {value}
              </div>
              <div className="text-[#B0B0C0] text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-227">
                {label}
              </div>
            </div>)}
        </div>

        {/* Coverage tags */}
        <div className="bg-[#0A0A0A] border border-[#d4af37]/20 rounded-2xl p-6 sm:p-8" data-id="element-228">
          <p className="text-center text-white text-xs font-black uppercase tracking-widest mb-5" data-id="element-229">
            Full coverage, every category
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-230">
            {tags.map(tag => <span key={tag} className="inline-flex items-center gap-1.5 bg-[#16161F] border border-[#d4af37]/20 text-white text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow-sm" data-id="element-231">
                <CheckIcon className="w-3.5 h-3.5 text-[#d4af37]" strokeWidth={3} data-id="element-232" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}